/**
 * Short line under a project title: tasks done, and a photo count when there is one.
 */

function taskList(tasks) {
  return Array.isArray(tasks) ? tasks : [];
}

function projectProgressCopy(tasks) {
  const list = taskList(tasks);
  const total = list.length;
  const done = list.filter((task) => task && task.completed).length;
  const noun = total === 1 ? 'task' : 'tasks';
  return `${done} of ${total} ${noun} done`;
}

function projectPhotoCopy(count) {
  const total = Math.max(0, Math.floor(Number(count) || 0));
  if (total < 1) return '';
  return total === 1 ? '1 photo' : `${total} photos`;
}

function projectPhotoCount(tasks, lookup) {
  return taskList(tasks).reduce((sum, task) => {
    if (typeof lookup === 'function') {
      const count = Number(lookup(task));
      return sum + (count > 0 ? count : 0);
    }
    const shots = task && task.photos;
    return sum + ((shots && shots.length) || 0);
  }, 0);
}

function projectSummaryLine(tasks, photoCount) {
  const progress = projectProgressCopy(tasks);
  const photos = projectPhotoCopy(photoCount);
  return photos ? `${progress} · ${photos}` : progress;
}

export {
  projectProgressCopy,
  projectPhotoCopy,
  projectPhotoCount,
  projectSummaryLine,
};
